import Box from '@mui/material/Box';
import Grid from '@mui/material/Unstable_Grid2';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Divider from '@mui/material/Divider';
import Blurb from '../../../Components/Blurb/Blurb';

export default function BallotContent({ 
  rcv,
  key,
  name, 
  img,
  selectedCandidate,
  setSelectedCandidate,
  selectedTwoHornsFirstChoice,
  setSelectedTwoHornsFirstChoice,
  selectedTwoHornsSecondChoice,
  setSelectedTwoHornsSecondChoice,
  selectedTwoHornsThirdChoice,
  setSelectedTwoHornsThirdChoice,
  selectedProopFirstChoice,
  setSelectedProopFirstChoice,
  selectedProopSecondChoice,
  setSelectedProopSecondChoice,
  selectedProopThirdChoice,
  setSelectedProopThirdChoice,
  selectedStainFirstChoice,
  setSelectedStainFirstChoice,
  selectedStainSecondChoice,
  setSelectedStainSecondChoice,
  selectedStainThirdChoice,
  setSelectedStainThirdChoice
}) {
  // const [ disabledFirstChoice, handleDisableCFirstChoice ] = useState(null);
  // const [ disabledSecondChoice, handleDisableCFirstChoice ] = useState(null);
  let disabled1;
  let disabled2;
  let disabled3;

  // if(name === 'Two Horns') {
  //   disabled1 = selectedProopFirstChoice || selectedStainFirstChoice;
  //   disabled2 = selectedTwoHornsSecondChoice;
  //   disabled3 = selectedTwoHornsThirdChoice;
  // } else if(name === 'Wrinkled Prune') {
  //   disabled1 = selectedTwoHornsFirstChoice || selectedStainFirstChoice;
  //   disabled2 = selectedProopSecondChoice;
  //   disabled3 = selectedProopThirdChoice;
  // } else if(name === 'Slight Stain') {
  //   disabled1 = selectedProopFirstChoice || selectedTwoHornsFirstChoice;
  //   disabled2 = selectedStainSecondChoice;
  //   disabled3 = selectedStainThirdChoice;
  // }

  const setSelected = (value, key) => {
    if(name === 'Two Horns') {
      if(value === "1") {
        disabled1 = selectedProopFirstChoice || selectedStainFirstChoice;
        disabled2 = selectedTwoHornsSecondChoice;
        disabled3 = selectedTwoHornsThirdChoice;
        setSelectedTwoHornsFirstChoice(value);
        setSelectedTwoHornsSecondChoice(true);
        setSelectedTwoHornsThirdChoice(true);
      } else if(value === "2"){
        disabled1 = selectedProopSecondChoice || selectedStainSecondChoice;
        disabled2 = selectedTwoHornsFirstChoice;
        disabled3 = selectedTwoHornsThirdChoice;
        setSelectedTwoHornsSecondChoice(value);
        setSelectedTwoHornsFirstChoice(true);
        setSelectedTwoHornsThirdChoice(true);
      } else if(value === "3"){
        setSelectedTwoHornsThirdChoice(value);
        setSelectedTwoHornsSecondChoice(true);
        setSelectedTwoHornsFirstChoice(true);
      }
    } else if(name === 'Wrinkled Prune') {
      if(value === "1") {
        setSelectedProopFirstChoice(value);
        setSelectedProopSecondChoice(true);
        setSelectedProopThirdChoice(true);
      } else if(key === 2){
        setSelectedProopSecondChoice(value);
      } else if(key === 3){
        setSelectedProopThirdChoice(value);
      }
    } else if(name === 'Slight Stain') {
      if(value === "1") {
        setSelectedStainFirstChoice(value);
        setSelectedStainSecondChoice(true);
        setSelectedStainThirdChoice(true);
      } else if(key === 2){
        setSelectedStainSecondChoice(value);
      } else if(key === 3){
        setSelectedStainThirdChoice(value);
      }
    }
  }

  const setDisabled = (value, key) => {
    console.log("valueeee", value)
    if(name === 'Two Horns') {
      if(key === 1) {
        return selectedProopFirstChoice || selectedStainFirstChoice;
      } else if(key === 2) {
        return selectedProopSecondChoice || selectedStainSecondChoice;
      } else if(key === 3) {
        return selectedProopThirdChoice || selectedStainThirdChoice;
      }
    } else if(name === 'Wrinkled Prune') {
      if(key === 1) {
        return selectedTwoHornsFirstChoice || selectedStainFirstChoice;
      } else if(key === 2) {
        return selectedTwoHornsSecondChoice || selectedStainSecondChoice;
      } else if(key === 3) {
        return selectedTwoHornsThirdChoice || selectedStainThirdChoice;
      }
    } else if(name === 'Slight Stain') {
      if(key === 1) {
        return selectedProopFirstChoice || selectedTwoHornsFirstChoice;
      } else if(key === 2) {
        return selectedProopSecondChoice || selectedTwoHornsSecondChoice;
      } else if(key === 3) {
        return selectedProopThirdChoice || selectedTwoHornsThirdChoice;
      }
    }
  }

  return (
    <Grid container direction="column" sx={{ justifyContent: 'center', textAlign: 'center', alignItems: 'center' }}>
      <Grid container direction="row" columnSpacing={3} sx={{ maxWidth: 330, justifyContent: 'space-between', textAlign: 'center', alignItems: 'center', paddingTop: 1 }}>
        <Grid>
          <Box
            sx={{
              maxWidth: '4rem',
              maxHeight: '4rem',
            }}
            component="img"
            src={img}
          />
        </Grid>
        {!rcv && <Grid xs={2} sx={{ textAlign: 'left' }}>
          <Blurb
            headline={name}
            headlineStyles={{ fontSize: '1rem' }}
          />
        </Grid>}
        <Grid sx={{ marginLeft: 3 }}>
          {rcv ? (
            <FormControl>
              <RadioGroup
                row
              >
                <FormControlLabel 
                  labelPlacement="top"
                  value="1"
                  key={1}
                  onChange={(e) => setSelected(e.target.value, e.target.key)}
                  disabled={disabled1}
                  control={<Radio />}
                />
                <FormControlLabel 
                  labelPlacement="top"
                  value="2"
                  key={2}
                  onChange={(e) => setSelected(e.target.value, e.target.key)}
                  disabled={disabled2}
                  control={<Radio />}
                />
                <FormControlLabel 
                  labelPlacement="top"
                  value="3"
                  key={3}
                  onChange={(e) => setSelected(e.target.value, e.target.key)}
                  disabled={disabled3}
                  control={<Radio />}
                />
              </RadioGroup>
            </FormControl>
          ) : (
            <Radio
              checked={selectedCandidate === name}
              onChange={(e) => setSelectedCandidate(e.target.value)}
              value={name}
              name="radio-buttons"
            />
          )}
        </Grid>
      </Grid>
      <Grid>
        {name !== 'Slight Stain' &&
          <Divider variant="middle" color="black" sx={{ width: 200, borderBottomWidth: 2 }} />
        }
      </Grid>
    </Grid>
  )
}